import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
// import { addToSlip, clearSlip } from "../utils/betslip";
import { setBetslipShareChoice, resetState } from "../../redux/matchesSlice";
import { useDispatch, useSelector } from "react-redux";
import { handleBetslipUpdate } from "../utils/redux-functions";
import { Button } from "antd";
import { getFromLocalStorage } from "../utils/local-storage";

const ConfirmShareBetslipModal = React.memo(() => {
  const dispatch = useDispatch();
  const { show_betslip_modal, betslip_share_choice, decoded_match } = useSelector(state => state.matchesData);
  const settings = getFromLocalStorage("settings");
  const [maxSelectionReached, setMaxSelectionReached]=useState(false);
  const betslipLength=useSelector((state)=>state.betting.betslipLength)
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [tooltipTimeout, setTooltipTimeout] = useState(null);

  const handleButtonClick = async (option) => {
    dispatch(setBetslipShareChoice(option));
  }

  const handleShareBetslip = () => {
    const actionType = betslip_share_choice; // 'add' or 'clear'
    handleBetslipUpdate(decoded_match, actionType, dispatch);
    dispatch(resetState('betslip_share_choice')); // Reset any state related to the modal
  };

  const closeModal = () => {
    dispatch(resetState('show_betslip_modal'));
  }

  useEffect(() => {
    if (betslip_share_choice !== null) {
      handleShareBetslip();
    }
  }, [betslip_share_choice]);
  
  useEffect(() => {
    if (decoded_match) {
        let totalBetslipLength = Object.keys(decoded_match).length + betslipLength;
        if (totalBetslipLength >= Number(settings?.sportsBookLimits?.multiBetMaxSelections)) {
            setMaxSelectionReached(true);
        }
    }
  }, [decoded_match, betslipLength]);

  const handleTouchStart = () => {
    if (maxSelectionReached) {
      setTooltipVisible(true);

      // Hide the tooltip after 5 seconds
      const timeoutId = setTimeout(() => {
        setTooltipVisible(false);
      }, 4000);

      setTooltipTimeout(timeoutId);
    }
  };

  const closeTooltip = () => {
    setTooltipVisible(false);
    
    if (tooltipTimeout) {
      clearTimeout(tooltipTimeout);
    }
  };

  return (
    <Modal
      show={show_betslip_modal}
      className={"shadow-lg filters-modal deposit-modal deposit-modal-body borderNone"}
      dialogClassName={"modal-31w"}
      centered={true}
      size={"md"}
      backdrop={"static"}
      style={{ zIndex: "9999" }}
    >
      <Modal.Header closeButton={false} className={"w-100"}>
        <Modal.Title className={"w-100"}>
          <div
            className={
              "d-flex justify-content-start align-items-centre flex-row px-4"
            }
          >
            <div style={{ width: "100%", textAlign: "center" }}>
                <strong className={""} style={{ width: "90%" }}>
                  Replace Selections?
                </strong>
            </div>
            <div className="close-history-filter1 deposit-modal">
                <input
                  id={"deposit"}
                  type="submit"
                  value="X"
                  onClick={closeModal}
                />
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="sticky-hidden" style={{ color: "white", textAlign: "center" }}>
            You have
            &nbsp;<span className="badge bg-warning rounded-pill" style={{ color: "black" }}>{betslipLength}</span>&nbsp;
            selection{betslipLength > 1 ? 's' : ''} in your Betslip. What would you like to do?
        </p>
        <div className={"d-flex flex-row m-btn-group "}>
            <button
              className="m-btn"
              style={{ marginRight: '5px' }}
              onClick={() => handleButtonClick('clear')}
            >
                Replace
            </button>
            <button
              className={`m-btn ${maxSelectionReached ? 'disabled' : ''}`} 
              onClick={() => handleButtonClick('add')}
              disabled={maxSelectionReached}
              title={maxSelectionReached && !tooltipVisible ? 'You have reached the maximum selections.' : ''}
              onTouchStart={handleTouchStart}
            >
                Combine
            </button>
            {/* Tooltip */}
            {tooltipVisible && maxSelectionReached && (
              <div className="tooltip1">
                <span className="tooltip-close" onClick={() => closeTooltip()}>&times;</span>
                You have reached the maximum selections.
              </div>
            )}
        </div>
      </Modal.Body>
      <Modal.Footer className={"text-center modal-width deposit-modal-footer d-flex justify-content-centre align-items-centre"}>
        <Button
          className={"cancel-filter-markets bg-deposit-modal-btn"}
          onClick={closeModal}
          style={{ color: "#fff", borderRadius: "5px", bottom: "0" }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
});
export default ConfirmShareBetslipModal;